import * as constants from './constants';
import reducer from './reducer';

export default {
    constants,
    reducer
};



// WEBPACK FOOTER //
// ./src/services/google/index.js